import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Hidden from '@material-ui/core/Hidden';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Menu from '@material-ui/core/Menu';
import MenuList from '@material-ui/core/MenuList';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import Fab from '@material-ui/core/Fab';
import KobooToolbar from './KobooToolbar';
import UserIcon from '../Icon/UserIcon';
import { KOBOO_LIGHT_GREY } from '../../constants/colors';
import AccountMenuItems from '../Menu/AccountMenuItems';
import RentMenuItems from '../Menu/RentMenuItems';
import stylesDefault from '../../constants/stylesDefault';

const styles = theme => ({
  largeLayout: {
    height: 'calc(100vh - 20px)',
    margin: '10px',
    width: 'calc(100vw - 20px)',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      height: '100vh',
      width: '100vw',
    },
  },
  avatar: {
    position: 'fixed',
    display: 'flex',
    justifyContent: 'center',
    top: '1em',
    right: '1em',
  },
  menu: {
    overflowY: 'auto',
    borderRight: '1px solid',
    borderColor: KOBOO_LIGHT_GREY,
    height: 'calc(100vh - 20px)',
    paddingRight: '20px',
  },
  body: {
    overflowY: 'auto',
    height: '100%',
    padding: '0 10px 80px',
  },
  grid: {
    maxHeight: 'calc(100vh - 20px)',
    boxSizing: 'border-box',
  },
});

class LargePaper extends Component {
    state = {
      accountMenuAnchor: null,
      drawerOpen: false,
    };

    static propTypes = {
      classes: PropTypes.object.isRequired,
    };

    handleClickAccountMenu = (event) => {
      this.setState({ accountMenuAnchor: event.currentTarget });
    };

    handleCloseAccountMenu = () => {
      this.setState({ accountMenuAnchor: null });
    };

    toggleDrawer = open => () => {
      this.setState({
        drawerOpen: open,
      });
    };

    render() {
      const { classes, children } = this.props;

      return (
            <Grid item xs={12}>

                {/** Account menu for web page * */}
                <Menu anchorEl={this.state.accountMenuAnchor}
                      open={Boolean(this.state.accountMenuAnchor)}
                      onClose={this.handleCloseAccountMenu}
                      id="account-menu">
                    <AccountMenuItems/>
                </Menu>

                {/** Drawer for mobile page * */}
                <Drawer open={this.state.drawerOpen} onClose={this.toggleDrawer(false)}>
                    <MenuList>
                        <RentMenuItems/>
                        <Divider light />
                        <AccountMenuItems/>
                    </MenuList>
                </Drawer>

                <Paper className={classes.largeLayout}>
                    <Grid container spacing={0}>
                        <Hidden smDown>
                            <Grid item md={2} className={classes.menu}>
                                <img alt="Koboo" src="/logo.svg" style={stylesDefault.logo}/>
                                <MenuList>
                                    <RentMenuItems/>
                                </MenuList>
                            </Grid>
                        </Hidden>
                        <Hidden mdUp>
                            <KobooToolbar openDrawer={this.toggleDrawer}/>
                        </Hidden>
                        <Grid item xs={12} sm={12} md={10} className={classes.grid}>
                            <div className={classes.body}>
                            {children}
                            </div>
                        </Grid>
                    </Grid>

                    <Hidden smDown>
                        <Fab
                          className={classes.avatar}
                          color="primary"
                          onClick={this.handleClickAccountMenu}
                        >
                            <UserIcon/>
                        </Fab>
                    </Hidden>
                </Paper>
            </Grid>
      );
    }
}

export default withStyles(styles)(LargePaper);



// WEBPACK FOOTER //
// ./src/components/Layout/LargePaper.jsx